var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PlayerTuto',{attrs:{"text":_vm.textContent.consigne.player2,"color-background":"enigme2","gif":_vm.gif}})}
var staticRenderFns = []

export { render, staticRenderFns }